const UNDERWATER_INSP = {
  alignment: null,
  brkey: "",
  calcScourDepth100: null,
  calcScourDepth500: null,
  changeSinceLastInsp: null,
  counterMeasure: null,
  debrisPotential: null,
  foundType: null,
  inspectionId: "",
  invFoundType: null,
  maxWaterDepth: null,
  updateDateTime: null,
  movement: null,
  obsScourDepth: null,
  obsScourRating: null,
  openAdeqChannel: null,
  previousCurrent: null,
  sar: 0,
  scbiCase: null,
  scbiCode: null,
  scourHole: null,
  scourUndermine: null,
  sedDeposit: null,
  streamBedMaterial: null,
  strUnitKey: "",
  subUnitType: null,
  subScour: null,
  underwaterInspDesc: null,
  underwaterInspType: null,
  updateUserId: null,
  veloStreamSlope: null,
};

const SCOUR_COMP = {
  brkey: null,
  inspectionId: null,
  debrisPotential: null,
  fabLocation: null,
  highWaterDate: "",
  highWaterElev: null,
  horDebrisEndPct: null,
  horDebrisStartPct: null,
  nabLocation: null,
  newHighWater: "",
  overallSAR: null,
  overallOSA: null,
  overtopDate: null,
  overTopping: null,
  overTopRisk: "",
  pressureFlow: null,
  reviewerAction: null,
  reviewerComment: null,
  scbiSource: null,
  scourCalculated: "",
  scourRecalc: "",
  streamBedMaterial1: null,
  streamBedMaterial2: null,
  streamBedMaterialDesc: null,
  trafficDelay: null,
  trappingPotential: null,
  unitsInspectedQty: null,
  updateDateTime: "",
  updateUserId: "",
  usLeftWWCond: null,
  usLeftWWPresence: null,
  usRightWWCond: null,
  usRightWWPresence: null,
  vertDebrisEndPct: null,
  vertDebrisStartPct: null,
};

export { UNDERWATER_INSP, SCOUR_COMP };
